import React, { useState } from "react";
import Head from "../modules/Head";
import HeaderComponent from "../components/HeaderComponent";
import "../modules/global.scss";
import "../pages/ZaboravljenPassword.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Button from "react-bootstrap/Button";
import "../components/FormValidationsWarning.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config.json";

function ZaboravljenPasswordFizickoLice() {
  const { baseUrl, token } = config;
  const navigate = useNavigate();
  const [responseMessage, setResponseMessage] = useState("");
  const onSubmit = async (values, { resetForm }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/auth/fizicko-lice-novi-password`,
        values,
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );
      setResponseMessage(response.data.message);
      navigate("/hvala-password-poslan-na-mail");
    } catch (error) {
      setResponseMessage(error.response.data.message);
    }
    resetForm();
  };
  const { handleBlur, handleChange, handleSubmit, values, errors, touched } =
    useFormik({
      initialValues: {
        email: "",
      },
      onSubmit,
      validationSchema: Yup.object({
        email: Yup.string()
          .required("Niste unijeli e-mail adresu.")
          .matches(
            /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
            "Unijeli ste pogrešan format e-mail adrese"
          ),
      }),
    });

  return (
    <form id="zaboravljen-password" onSubmit={handleSubmit}>
      <Head title="Zaboravljen password" />
      <HeaderComponent title="Zaboravljen Password" />
      <div className="passRecoveryInputField">
        <input
          type="text"
          name="email"
          id="passRecoveryInputField"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
        />
        {touched.email && errors.email ? (
          <span className="input-error" id="passRecoveryInputField-error">
            {errors.email}
          </span>
        ) : null}
        <label id="labelPassRecoveryInputField" for="PassRecoveryInputField">
          Unesite e-mail za recovery
        </label>

        <Button
          type="submit"
          id="primary"
          className="okButton btn btn-success btn-lg"
          variant="success"
        >
          OK
        </Button>
        <Link
          to="/"
          className="cancelButton btn btn-danger btn-lg"
          id="danger"
        >
          ODUSTAJEM
        </Link>
      </div>
      <b id="responseMessage">{responseMessage}</b>
    </form>
  );
}

export default ZaboravljenPasswordFizickoLice;
